module.exports = __webpack_public_path__ + "img/logo-xbox-series-xs.df02397c.svg";